import type { RouteLocationNamedRaw } from 'vue-router';

export enum EPosition {
  left = 'left',
  right = 'right',
  center = 'center',
}

export enum EAlignIconType {
  text = 'text',
  horizontal = 'horizontal',
  vertical = 'vertical',
}

export interface IBreadcrumb {
  id: string;
  name: string;
  to: {
    name: string;
    params: { [x: string]: any };
  };
}

export enum ContentTypes {
  component = 'component',
  template = 'template',
}

export type IOption = {
  label: string;
  code: string | number;
  icon?: string;
};

export type ISettings = {
  [x: string]: string;
};

export type IContents = {
  [x: string]: string;
};

export enum EImageT1GridTypes {
  one = 'one',
  two = 'two',
  three = 'three',
  four = 'four',
  five = 'five',
}

export enum EImageT2GridTypes {
  first = 'first',
  second = 'second',
  third = 'third',
  fourth = 'fourth',
}

export enum EVideoGridTypes {
  first = 'first',
  second = 'second',
  third = 'third',
  fourth = 'fourth',
}

export enum EActionSelectCodes {
  default = 'default',
  link = 'link',
  modal = 'modal',
  customPageModal = 'customPageModal',
  customPage = 'customPage',
}

export enum EComponentPlacement {
  bottom = 'bottom',
  top = 'top',
}

export enum EGridIconsComponentType {
  firstImage = 'firstImage',
  secondImage = 'secondImage',
  firstVideo = 'firstVideo',
}

export type ISettingConfig = {
  secondMenus: {
    [key: string]: {
      type: string;
      component: Component;
      fields?: string[];
      list?: string;
      textSettings?: string[];
    };
  };
  defaults?: { [x: string]: any };
};

export type ILinearContentConfig = {
  isTree?: false;
  secondMenus?: {
    [key: string]: {
      type: string;
      component: Component;
    };
  };
  thirdMenus?: {
    [key: string]: {
      type: string;
      component: Component;
    };
  };
  defaults?: { [x: string]: any };
};

export type ITreeMenu = {
  component: Component;
  defaultItem?: { [x: string]: any };
};

export type ITreeRootList = {
  menus: { [menuName: string]: ITreeMenu };
};

export type ITreeContentConfig = {
  isTree: true;
  menus: { [menuName: string]: any };
  defaults?: { [x: string]: any };
};

export type IContentConfig = ILinearContentConfig | ITreeContentConfig;

export type IConfig = {
  settings: ISettingConfig;
  contents?: IContentConfig;
  defaults?: { [x: string]: any };
};
export interface IImage {
  src: string;
}
export interface ISelectedField {
  titleIndex: number;
}

export interface IContact {
  address: string;
  email: string;
  phone: string;
}

export interface IFormField {
  type: string;
  text: string;
  name: string;
  required: boolean;
}

export interface IActionField {
  action?: EActionSelectCodes;
  link: string;
  title: string;
  customPageId?: number;
  isOpenInNewTab: boolean;
}

export type IActionImageField = IActionField & {
  image: string;
};

export type IActionVideoField = IActionField & {
  video: string;
};

export interface IListImage {
  image: string;
}

export interface IContactField {
  isIndividualSettings: boolean;
  contactsColor: string;
  contactsFontFamily: string;
  contactsFontWeight: string;
  contactsFontSize: string;
  contactsLineHeight: string;
  contactsLetterSpacing: string;
  contactsFontStyle: string;
  contactsTextAlign: string;
  contactsTextTransform: string;
  contactsHoverTextColor: string;
  contactsHoverBackgroundColor: string;
  contactsHoverColor: string;
  contactsHoverFontWeight: string;
  contactsTextDecoration: string;
}

export enum ERouteScope {
  articles = 'articles',
  news = 'news',
}

export type IFindParams = {
  [x: string]: any;
};

export enum EFileListActionType {
  download = 'download',
  remove = 'remove',
}

export enum EItemListActions {
  edit = 'edit',
  delete = 'delete',
  hide = 'hide',
  add = 'add',
  newFolder = 'new-folder',
  enterFolder = 'enter-folder',
  dropdown = 'dropdown',
  addCard = 'add-card',
}

export enum ECustomPageLocations {
  horizontal = 'horizontal_menu',
  vertical = 'vertical_menu',
}

export interface IManageMenuItem {
  id: string;
  title: string;
  route?: RouteLocationNamedRaw;
}

export enum EMediaTypes {
  desktop = 'desktop',
  tablet = 'tablet',
  mobile = 'mobile',
}
